import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import { makeStyles, useTheme } from '@mui/styles';
import Drawer from '@mui/material/Drawer';
import Typography from '@mui/material/Typography';
import {
  Link,
  Redirect,
  useNavigate,
  useLocation,
  useRouteMatch,
  Outlet,
} from 'react-router-dom';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import {
  AddCircleOutlineOutlined,
  SubjectOutlined,
  AssistantPhoto,
} from '@mui/icons-material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import BookIcon from '@mui/icons-material/Book';
// import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { format } from 'date-fns';
import Avatar from '@mui/material/Avatar';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
// import AccountCircle from '@material-ui/icons/AccountCircle';
import MailIcon from '@mui/icons-material/Mail';
import NotificationsIcon from '@mui/icons-material/Notifications';
import HomeIcon from '@mui/icons-material/Home';
import RuleIcon from '@mui/icons-material/Rule';
import WysiwygIcon from '@mui/icons-material/Wysiwyg';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import EventBus from '../common/EventBus';
import { logout } from '../actions/auth';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import UserService from '../services/user.service';
import SessionService from '../common/CheckSession';
// import Hidden from '@material-ui/core/Hidden';
import MenuIcon from '@mui/icons-material/Menu';
import Divider from '@mui/material/Divider';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { styled, useTheme } from '@mui/material/styles';
import MuiAppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import CssBaseline from '@mui/material/CssBaseline';
import { makeStyles } from '@mui/styles';

// ยังไม่ได้ลอง
// gg : mui v5 drawer hidden
// How to Customize Material-UI Drawer Width, Color, Position Under AppBar, and More
// https://smartdevpreneur.com/the-definitive-tutorial-to-the-material-ui-drawer-component/

//legacy MUIv4.
const useStyles = makeStyles((theme) => {
  return {
    root: {
      display: 'flex',
    },
    drawer: {
      [theme.breakpoints.up('sm')]: {
        width: drawerWidth,
        flexShrink: 0,
      },
    },
    appBar: {
      [theme.breakpoints.up('sm')]: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
      },
    },
    menuButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        display: 'none',
      },
    },
    toolbar: theme.mixins.toolbar,
    drawerPaper: {
      width: drawerWidth,
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },

    page: {
      background: '#f9f9f9',
      width: '100%',
      padding: theme.spacing(3),
    },
    avatar: {
      marginLeft: theme.spacing(2),
    },
    active: {
      background: '#f4f4f4',
    },
    title: {
      padding: theme.spacing(2),
      fontSize: 17,
      fontWeight: 'bold',
    },
    date: {
      flexGrow: 1,
    },

    grow: {
      flexGrow: 1,
    },
    sectionDesktop: {
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: 'flex',
      },
    },
  };
});

const titleStyles = {
  //pantone 123c M20 Y100, #FFC72C
  //https://icolorpalette.com/color/pantone-123-c
  backgroundColor: '#FFFFFF',
  // paddingBottom: 2,
  // paddingRight: 2,
  // marginTop: 2,
  // marginLeft: 'auto',
  // marginRight: 'auto',
  // maxWidth: 500,
};

// const drawerWidth = 240;
const drawerWidth = 275;

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(0),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  })
);

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));

export default function Layout({ children }, props) {
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(true);
  const { user: currentUser } = useSelector((state) => state.auth);
  const [content, setContent] = useState('');
  const classes = useStyles();
  const [showModeratorBoard, setShowModeratorBoard] = useState(false);
  const [showAdminBoard, setShowAdminBoard] = useState(false);
  const [showMenu1, setShowMenu1] = useState(false);
  const [menuByRole, setMenuByRole] = useState([]);

  useEffect(() => {
    console.log('------NinjaLayout.js----useEffect----');
    SessionService.check(setContent);
  });

  // useEffect(() => {
  //   setOpen(true);
  // }, []);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const menuItems = [
    // {
    //   text: 'My Notes',
    //   icon: <SubjectOutlined color="secondary" />,
    //   path: '/ninja-notes',
    // },
    // {
    //   text: 'Create Note',
    //   icon: <AddCircleOutlineOutlined color="secondary" />,
    //   path: `/ninja-create`,
    // },
    // {
    //   text: 'Registration',
    //   icon: <AccountCircleIcon color="secondary" />,
    //   path: `/ninja-egat-regist`,
    // },
    // {
    //   text: 'Form Submit',
    //   icon: <BookIcon color="secondary" />,
    //   path: `/ninja-form-submit`,
    // },
    // {
    // text: 'Vertical Tabs',
    //   text: 'Home',
    //   icon: <BookIcon color="secondary" />,
    //   path: `/employment/ninja-egat-tabs`,
    // },
    {
      // text: 'Vertical Tabs',
      role: 'ROLE_USER',
      text: 'Home',
      icon: <BookIcon color="secondary" />,
      path: `/app/employment/home`,
    },
    {
      // text: 'Employment Form',
      role: 'ROLE_USER',
      text: 'บันทึกข้อมูล',
      icon: <AssignmentIndIcon color="secondary" />,
      path: `/app/employment/employment-form`,
    },
    // เมนูสำหรับเจ้าหน้าที่
    {
      // text: 'Customer Form',
      role: 'ROLE_MODERATOR',
      text: 'ตรวจสอบข้อมูล',
      icon: <AssignmentTurnedInIcon color="secondary" />,
      path: `/app/employment/hr-inspection`,
    },
    {
      // text: 'Property Listing Form',
      role: 'ROLE_MODERATOR',
      text: 'ออกรายงาน',
      icon: <WysiwygIcon color="secondary" />,
      path: `/app/employment/hr-inspection-report`,
    },

    // {
    //   // text: 'Property Listing Form',
    //   text: 'test1',
    //   icon: <AssignmentIndIcon color="secondary" />,
    //   path: `/employment/employment-form-test1`,
    // },
    // {
    //   // text: 'Property Listing Form',
    //   text: 'test2',
    //   icon: <AssignmentIndIcon color="secondary" />,
    //   path: `/employment/employment-form-test2`,
    // },

    // {
    //   text: 'Stepper1',
    //   icon: <AssignmentIndIcon color="secondary" />,
    //   path: `/employment/stepper1`,
    // },
    // {
    //   text: 'Stepper2',
    //   icon: <AssignmentIndIcon color="secondary" />,
    //   path: `/employment/stepper2`,
    // },
    // {
    //   text: 'Stepper3',
    //   icon: <AssignmentIndIcon color="secondary" />,
    //   path: `/employment/stepper3`,
    // },
  ];

  const backToHome = () => {
    navigate('/app/home');
    // history.go(0);
    // navigate(-1);
  };

  const nav = (path) => {
    // console.log(location.pathname);
    navigate(path);
  };

  const logOut = useCallback(() => {
    dispatch(logout());
  }, [dispatch]);

  useEffect(() => {
    if (currentUser) {
      setShowModeratorBoard(currentUser?.roles?.includes('ROLE_MODERATOR'));
      setShowAdminBoard(currentUser?.roles?.includes('ROLE_ADMIN'));
      setShowMenu1(currentUser?.roles?.includes('ROLE_MENU1'));

      // console.log('-----NinjaLayout.js----currentUser----', currentUser);

      const desiredObject = menuItems.filter(
        (obj) => obj.role == currentUser?.roles
      );
      setMenuByRole((old) => [...old, ...desiredObject]);

      // let target = []
      // menuItems.map(x => {
      //   target.push(x);
      // })
      // console.log('-----NinjaLayout.js----target----', target);
      // console.log('-----NinjaLayout.js----menuItems----', menuItems);
      // console.log('-----NinjaLayout.js----currentUser.roles----', currentUser.roles);
      // const secondArray = [ ...desiredObject ];
      // console.log('-----NinjaLayout.js----secondArray----', secondArray);
      // setMenuByRole([{a:1, b:2}]);
      // console.log('-----NinjaLayout.js----menuByRole5----', menuByRole);
    } else {
      setShowModeratorBoard(false);
      setShowAdminBoard(false);
      setShowMenu1(false);
    }

    EventBus.on('logout', () => {
      logOut();
    });

    return () => {
      EventBus.remove('logout');
    };
  }, [currentUser, logOut]);

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar position="fixed" open={open}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{ mr: 2, ...(open && { display: 'none' }) }}
          >
            <MenuIcon />
          </IconButton>
          {/* <Typography variant="h6" noWrap component="div">
            Persistent drawer
          </Typography> */}
          <Typography className={classes.date}>
            Today is the {format(new Date(), 'do MMMM Y')}
          </Typography>
          <div className={classes.grow} />
          <div className={classes.sectionDesktop}>
            {/* <IconButton aria-label="show 4 new mails" color="inherit">
              <Badge badgeContent={4} color="secondary">
                <MailIcon />
              </Badge>
            </IconButton> */}
            {/* กระดิ่ง */}
            {/* <IconButton aria-label="show 17 new notifications" color="inherit">
              <Badge badgeContent={17} color="secondary">
                <NotificationsIcon />
              </Badge>
            </IconButton> */}
            {/* ปุ่มโฮม */}
            {/* <IconButton
              // edge="end"
              // aria-label="account of current user"
              // aria-controls={menuId}
              aria-haspopup="true"
              // onClick={() => {history.push("/home"); history.go(0)}}
              // onClick={() => <Redirect to="/home" />}
              onClick={backToHome}
              color="inherit"
            >
              <HomeIcon />
            </IconButton> */}
            <IconButton color="inherit" onClick={logOut}>
              <ExitToAppIcon />
            </IconButton>
            {/* <a href="/login" onClick={logOut}>
              LogOut
            </a> */}
            {/* <Link to="/back-to-user">Home</Link> */}
            {/* <Avatar className={classes.avatar} src="/mario-av.png" /> */}
            <Avatar className={classes.avatar} src="/emp1.png" />
          </div>
        </Toolbar>
      </AppBar>
      <nav className={classes.drawer} aria-label="mailbox folders">
        <Drawer
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            '& .MuiDrawer-paper': {
              width: drawerWidth,
              boxSizing: 'border-box',
            },
          }}
          variant="persistent"
          anchor="left"
          open={open}
        >
          {/* *********************************
           *
           *
           *               drawer
           *
           *
           ************************************/}
          <DrawerHeader sx={titleStyles}>
            <div>
              <Typography className={classes.title}>
                EGAT Employment Application
              </Typography>
            </div>
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === 'ltr' ? (
                <ChevronLeftIcon />
              ) : (
                <ChevronRightIcon />
              )}
            </IconButton>
          </DrawerHeader>
          <Divider />
          <List>
            {menuByRole.map((item) => (
              <ListItem
                button
                key={item.text}
                onClick={() => navigate(item.path)}
                className={
                  location.pathname == item.path ? classes.active : null
                }
              >
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItem>
            ))}
            {/* {menuByRole.map((item) => {
              return (
                <>
                  <p>{item.text}</p>
                </>
              );
            })} */}
            {/* {menuItems.map((item) => (
              <ListItem
                button
                key={item.text}
                onClick={() => navigate(item.path)}
                className={
                  location.pathname == item.path ? classes.active : null
                }
              >
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItem>
            ))} */}

            {/* {menuByRole.map((item) => (
              <ListItem
                button
                key={item.text}
                onClick={() => navigate(item.path)}
                className={
                  location.pathname == item.path ? classes.active : null
                }
              >
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItem>
            ))} */}

            {/* {['Inbox', 'Starred', 'Send email', 'Drafts'].map((text, index) => (
              <ListItem button key={text}>
                <ListItemIcon>
                  {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
                </ListItemIcon>
                <ListItemText primary={text} />
              </ListItem>
            ))} */}
          </List>
          <Divider />
          <List>
            {/* {['All mail', 'Trash', 'Spam'].map((text, index) => (
              <ListItem button key={text}>
                <ListItemIcon>
                  {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
                </ListItemIcon>
                <ListItemText primary={text} />
              </ListItem>
            ))}
            <Divider /> */}

            {/* <ListItem
              button
              key="Test"
              // component={Link}
              // to={'ninja-egat-customer-form'}
              onClick={() => navigate(`/ninja/ninja-egat-customer-form`)}
            >
              <ListItemIcon>
                <InboxIcon color="secondary" />
              </ListItemIcon>
              <ListItemText primary="Test" />
            </ListItem> */}
            <ListItem button key="Logout" onClick={logOut}>
              <ListItemIcon>
                <ExitToAppIcon color="secondary" />
              </ListItemIcon>
              <ListItemText primary="Logout" />
            </ListItem>
          </List>
          {/* <Link to="ninja-egat-customer-form">child 1</Link> ||||{' '} */}
        </Drawer>
      </nav>
      <Main open={open}>
        {/* main content */}
        <div className={classes.page}>
          {/* <div className={classes.toolbar}></div> */}
          {children}
          {/* <Outlet /> */}
        </div>
      </Main>
    </Box>
  );
}
